export const LAYER_CONFIG_OMIT_PROP = ['name', 'data', 'onClick', 'onHover', 'onLoaded', 'onLoadFailed'];
